<header class="header-area transparent">
    <div class="container">
        <div class="row no-gutter align-items-center position-relative">
            <div class="col-12">
                <div class="header-align">
                    <div class="header-align-start">
                        <div class="header-logo-area">
                            <a href="index.html" id="landingpageimage_path">
                                <img class="logo-main" src="../../../../assets/images/new-images/OUK_Logo 1.png"
                                    alt="Logo" />
                                <img class="logo-light" src="../../../../assets/images/new-images/OUK_Logo 1.png"
                                    alt="Logo" />
                            </a>
                        </div>
                    </div>
                    <div class="header-align-center">
                        <div class="header-navigation-area position-relative">
                            <ul class="main-menu nav mb-0">
                                <!-- <li (click)="isSS('d');"><a routerLink="/default"><span>Home</span></a></li>
                                <li (click)="isSS('a');"><a routerLink="/about"><span>About</span></a></li>
                                <li (click)="isSS('j');"><a routerLink="/job"><span>Jobs</span></a></li>
                                <li (click)="isSS('i');"><a routerLink="/internship"><span>Internships</span></a></li>
                                <li (click)="isSS('c');"><a routerLink="/corporate"><span>Corporates</span></a></li>
                                <li (click)="isSS('p');"><a routerLink="/contacts"><span>Contact</span></a></li> -->
                                <li (click)="isSS('d');"><a [routerLink]="['/default']"><span>Home</span></a></li>
                                <li (click)="isSS('a');"><a [routerLink]="['/about']"><span>About</span></a></li>
                                <li (click)="isSS('j');"><a [routerLink]="['/job']"><span>Jobs</span></a></li>
                                <li (click)="isSS('i');"><a [routerLink]="['/internship']"><span>Internships</span></a>
                                </li>
                                <li (click)="isSS('c');"><a [routerLink]="['/corporate']"><span>Start-ups</span></a>
                                </li>
                                <li (click)="isSS('p');"><a [routerLink]="['/contacts']"><span>Contact</span></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="header-align-end">
                        <div class="header-action-area">
                            <a class="btn-registration w-auto ps-3 pe-3 me-2" aria-current="page"
                                [routerLink]="['/login']">Login</a>
                            <a class="btn-registration w-auto ps-3 pe-3" data-bs-toggle="modal"
                                data-bs-target="#signupModal">
                                Signup</a>
                            <button type="button" class="btn-menu" data-bs-toggle="offcanvas"
                                data-bs-target="#AsideOffcanvasMenu" aria-controls="AsideOffcanvasMenu">
                                <i class="icofont-navigation-menu"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<app-landing-home *ngIf="isSS('d')"></app-landing-home>
<app-landing-about *ngIf="isSS('d') || isSS('a')"></app-landing-about>
<!-- <app-tutor-home *ngIf="isSS('d') || isSS('j')"></app-tutor-home>  -->
<app-landing-jobs *ngIf="isSS('d') || isSS('j')"></app-landing-jobs>
<app-landing-interns *ngIf="isSS('i')"></app-landing-interns>
<app-landing-corporate *ngIf="isSS('c')"></app-landing-corporate>
<app-landing-contact *ngIf="isSS('p')"></app-landing-contact>
<section class="sec-overlay sec-overlay-theme bg-img" *ngIf="isSS('d')"
    style="background-image: url('../../../assets/images/new-images/dashboard.png');">
    <div class="container pt--0 pb--0">
        <div class="row justify-content-center divider-style1 pb-1 pt-5">
            <div class="col-lg-10 col-xl-7">
                <div class="divider-content text-center">
                    <h4 class="sub-title aos-init aos-animate mb-0" data-aos="fade-down">
                        Celebrating the impactful <br /> achievements we've accomplished together.
                    </h4>
                    <ul class="d-flex justify-content-evenly border-0 bg-transparent text-center ps-0 mt-3">
                        <li class="list-group-item border-0 bg-transparent">
                            <h2 class="text-white">{{getCount('STUDENTS')}}+</h2>
                            <img src="assets/img/icons/student.png" width="30px" width="30px" class="img-fluid" alt="">
                            <h6 class=" mt-3 text-white">Students</h6>
                        </li>
                        <li class="list-group-item border-0 bg-transparent">
                            <h2 class="text-white">{{getCount('COURSES')}}+</h2>
                            <img src="assets/img/icons/courses.png" width="30px" width="30px" class="img-fluid" alt="">
                            <h6 class=" mt-3 text-white">Courses</h6>
                        </li>
                        <li class="list-group-item border-0 bg-transparent">
                            <h2 class="text-white">{{getCount('TUTORS')}}+</h2>
                            <img src="assets/img/icons/Trainer.png" width="30px" width="30px" class="img-fluid" alt="">
                            <h6 class="mt-3 text-white">Trainers</h6>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-layer-style1"></div>
    <div class="bg-layer-style2"></div>
</section>
<section class="testimonial-area bg-color-gray" *ngIf="isSS('d')">
    <div class="container" data-aos="fade-down">
        <div class="row">
            <div class="col-12">
                <div class="section-title text-center">
                    <h3 class="title">What Our Students Are Saying</h3>
                    <div class="desc">
                        <p>Real stories from OUK learners who turned internships into life-changing opportunities.

                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="testimonial-area">
                    <div class="">
                        <div class="testimonials123 owl-theme">
                            <div class="item mb-2" *ngFor="let monials of testMonialsList">
                                <div class="testimonial-item">
                                    <div class="testi-inner-content">
                                        <div class="testi-author">
                                            <div class="d-flex justify-content-between">
                                                <div class="testi-thumb">
                                                    <img [src]="monials.image" class="img-fluid" width="75" height="75"
                                                        alt="{{monials.name}}">
                                                </div>
                                                <div class="testi-info">
                                                    <h4 class="name">{{ monials.name }}</h4>
                                                    <span class="designation">{{ monials.designation }}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="testi-content">
                                            <p class="desc">{{ monials.description }}</p>
                                            <div class="rating-box">
                                                <i class="icofont-star" *ngFor="let star of [1,2,3,4,5]"></i>
                                            </div>
                                            <div class="testi-quote">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-quote" viewBox="0 0 16 16">
                                                    <path
                                                        d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388q0-.527.062-1.054.093-.558.31-.992t.559-.683q.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 9 7.558V11a1 1 0 0 0 1 1zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612q0-.527.062-1.054.094-.558.31-.992.217-.434.559-.683.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 3 7.558V11a1 1 0 0 0 1 1z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<div class="container pb-0 pt-0 mt-5 mb-5" *ngIf="isSS('d')">
    <div class="row align-items-center g-4">
        <div class="col-lg-5 col-md-6">
            <img src="../../../../assets/images/new-images/Career-Journey.jpg" class=" img-fluid" />
        </div>
        <div class="col-lg-7 col-md-6 mt-5 mt-md-0">
            <div class="ms-lg-5">
                <h3 class="mb-4 display-6 fw-semibold">Your Career Journey Starts Here</h3>
                <p class="text-muted mb-4">
                    <strong>Join thousands of OUK learners already building their future through internships and job
                        opportunities.</strong>
                </p>
                <p class="text-muted mb-4">
                    <strong>Whether you're looking for your first internship, a foot in the door at a top company, or
                        real-world experience in your field — it all begins with one click.
                        Create your profile to apply for internships, track your progress, and get matched with roles
                        that fit your goals.</strong>
                </p>
                <ul class="list-unstyled text-muted mb-1">
                    <li class="mb-2 d-flex align-items-center">
                        <i class="bi-check-circle text-emerald-600 fs-5 me-2 text-success"></i>
                        Over 2,000 students already placed
                    </li>
                    <li class="mb-2 d-flex align-items-center">
                        <i class="bi-check-circle text-emerald-600 fs-5 me-2 text-success"></i>
                        Opportunities from 100+ verified companies

                    </li>
                    <li class="mb-2 d-flex align-items-center">
                        <i class="bi-check-circle text-emerald-600 fs-5 me-2 text-success"></i>
                        Open to all OUK students and recent graduates
                    </li>

                </ul>

                <p> <a (click)="ApplyNow()" class="btn-theme btn-sm mb-2">Create Your Account</a> <small> Takes 2
                        minutes. Totally
                        free. </small> <br>
                    <small><a [routerLink]="['/login']"> Already Registered? </a>&nbsp;<a [routerLink]="['/login']"> Log
                            In </a> Pick up where you left off.
                        &nbsp; </small>
                </p>

            </div>
        </div>
    </div>
</div>

<app-footer-new></app-footer-new>
<div class="modal fade" id="signupModal" tabindex="-1" aria-labelledby="signupModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title" id="signupModalLabel">Signup&nbsp;<i
                        class="bi bi-info-circle-fill small text-secondary" data-bs-toggle="tooltip" data-bs-html="true"
                        data-bs-placement="right" data-bs-custom-class="custom-tooltip" title="
   <b>1. Job Seeker:</b> Create your profile to explore job and internship opportunities.<br>
   <b>2. Company:</b> Post jobs, manage applications, and hire talent.<br>
   <b>3. Founder:</b> Showcase your startup and connect with investors.<br>
   <b>4. Incubator:</b> Support startups with mentorship and resources.<br>
   <b>5. Investor:</b> Discover investment-ready startups and insights.">
                    </i>

                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" id="cls" aria-label="Close"></button>
            </div>




            <div class="modal-body">
                <!-- Signup form or content -->
                <label for="floatingSelectDisabled">I am a</label>
                <div class="">
                    <select class="form-select" (change)="signUPLogin($any($event.target).value)">
                        <option>Select</option>
                        <option value="1">Company</option>
                        <option value="2">Job Seeker</option>
                        <option value="3">Founder</option>
                        <option value="4">Incubator</option>
                        <option value="5">Investor</option>
                    </select>

                </div>


            </div>

            <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Submit</button>
            </div> -->

        </div>
    </div>
</div>